import { useState } from "react";
import useUser from "../../../../core/hooks/use-user";
import useModal from "../../../../core/hooks/use-modal";
import FormSecuenciasTurnos from "../components/form-nomina-secuencias";
import { sweetAl, toast } from "../../../../core/helpers/message-helper";
import Datatable from "../../../../core/ui/components/Datatable";
import { API_URL } from "../../../../core/config/env";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";

import "../components/styles.css";

import {
    activarSecuencia,
    inactivarSecuencia,
    obtenerSecuenciaPorId,
} from "../../services/nomina-secuencias-service";
import FormAsignarSecuencias from "../components/form-asignar-nomina-secuencias";

const NominaSecuencias = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();

    const [dtInstance, onDtInstance] = useState({});

    const modalAsignar = useModal({
        data: { secuencia: {} },
    });

    const modalSecuencias = useModal({
        title: "Crear Secuencia",
        data: { secuencia: {} },
    });

    const onSaved = (response) => {
        toast.success(response.message);
        modalSecuencias.set({
            show: false,
            data: {
                secuencia: {},
            },
        });

        dtInstance.ajax.reload();
    };

    const getDtInstance = (dt) => onDtInstance(dt);

    let tableButtons = [];

    if (userCan("nominaCrearSecuencias")) {
        tableButtons.push({
            titleAttr: "Crear Secuencia",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalSecuencias.set({
                    show: true,
                    title: "Crear Secuencia",
                    data: { secuencia: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("nominaEditarSecuencias")) {
        tableButtons.push({
            titleAttr: "Editar Secuencia",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await obtenerSecuenciaPorId(data.id);
                if (!resp.status) return toast.error(resp.message);
                mostrarModalEdicion(resp.data);
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("nominaInactivarSecuencias")) {
        tableButtons.push({
            titleAttr: "Inactivar Secuencia",
            text: '<i class="fas fa-trash"></i>',
            className: "btn btn-sm btn-danger",
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const valor = await sweetAl.confirm(
                    "¿Seguro que desea inactivar esta secuencia?"
                );

                if (!valor) {
                    return sweetAl.warning("No se ha inactivado la secuencia");
                }

                const resp = await inactivarSecuencia(data.id);

                if (!resp.status) {
                    return sweetAl.error(
                        "Ha ocurrido un error al inactivar la secuencia"
                    );
                }

                sweetAl.success("La secuencia fue inactivada correctamente");
                dt.ajax.reload();
            },
        });
    }

    if (userCan("nominaActivarSecuencias")) {
        tableButtons.push({
            titleAttr: "Activar Secuencia",
            text: '<i class="fas fa-check"></i>',
            className: "btn btn-sm btn-primary",
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const valor = await sweetAl.confirm(
                    "¿Seguro que desea activar esta secuencia?"
                );

                if (!valor) {
                    return sweetAl.warning("No se ha activado la secuencia");
                }

                const resp = await activarSecuencia(data.id);
                if (!resp.status) {
                    return sweetAl.error(
                        "Ha ocurrido un error al activar la secuencia"
                    );
                }

                sweetAl.success("La secuencia fue activada");
                dt.ajax.reload();
            },
        });
    }

    if (userCan("nominaAsignarSecuencias")) {
        tableButtons.push({
            titleAttr: "Asignar A Empleados",
            text: '<i class="fas fa-check-double"></i>',
            action: async function (_, dt) {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const resp = await obtenerSecuenciaPorId(data.id);
                if (!resp.status) return toast.error(resp.message);

                if (data && data.status == 1) {
                    modalAsignar.set({
                        show: true,
                        data: { secuencia: resp.data },
                    });
                }
            },
            className: "btn btn-sm btn-salmon",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "secuencias",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const mostrarModalEdicion = (secuencia) => {
        modalSecuencias.set({
            show: true,
            title: "Editar Secuencia",
            data: { secuencia },
        });
    };

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaSecuencias",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/secuencias`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de secuencias"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "secuencia_turnos_sedes", defaultValue: "" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: 2,
                createdCell: function (td, cellData = []) {
                    const secuencia = cellData
                        .map((turno) => {
                            return `
                            <div style="width: 50px; height: 50px; background-color: ${turno.color}" class="border d-flex justify-content-center align-items-center">
                                <span>${turno.sigla}</span>
                            </div>
                        `;
                        })
                        .join("");

                    td.innerHTML = `
                        <div class="d-flex justify-content-center">
                            ${secuencia}
                        </div>
                    `;
                },
            },
            {
                targets: 3,
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    NÓMINA / Secuencias
                </div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover text-center"
                    id="tablaSecuencias"
                >
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">Nombre</th>
                            <th className="text-center text-white">
                                Secuencia Turnos
                            </th>
                            <th className="text-center text-white">Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            <FormSecuenciasTurnos
                modalState={modalSecuencias}
                onCreated={onSaved}
            />
            <FormAsignarSecuencias modalState={modalAsignar} />
        </ContentWrapper>
    );
};

export default NominaSecuencias;
